<div class="row mb-4 filtros-row">
  <div *ngFor="let filter of filtersConfig" class="col-md-4 mb-2">
    <label
      class="form-label filtro-label text-default-label"
      [style.color]="filter.labelColor || defaultLabelColor"
    >
      {{ filter.label }}
    </label>

    <!-- Input de texto -->
    <input
      *ngIf="filter.type === 'text'"
      type="text"
      class="form-control"
      [placeholder]="filter.placeholder || 'Digite aqui a informação'"
      [value]="getFilterValue(filter.key)"
      (input)="onFilterChange(filter.key, $event.target.value)"
    />

    <!-- Input de data -->
    <input
      *ngIf="filter.type === 'date'"
      type="date"
      class="form-control"
      [value]="getFilterValue(filter.key)"
      (change)="onFilterChange(filter.key, $event.target.value)"
    />

    <!-- Select com ng-select -->
    <ng-select
      *ngIf="filter.type === 'select'"
      [items]="getSelectItems(filter) | async"
      [placeholder]="filter.placeholder || 'Selecione uma opção'"
      [loading]="selectLoading[filter.key]"
      [typeahead]="filter.typeahead ? selectInput$[filter.key] : null"
      [ngModel]="getFilterValue(filter.key)"
      [bindLabel]="filter.bindLabel || 'name'"
      [bindValue]="filter.bindValue || 'id'"
      (ngModelChange)="onFilterChange(filter.key, $event)"
      (typeahead)="onSelectInputChange(filter.key, $event)"
      clearable="true"
      notFoundText="Nenhum item encontrado"
    >
      <ng-template ng-option-tmp let-item="item">
        <div>
          {{ getDisplayValue(item, filter) }}
        </div>
      </ng-template>
    </ng-select>
  </div>
</div>
